import { Button, Card, TextField, RadioGroup, FormControlLabel, Radio, Box, InputAdornment, Typography, FormControl, InputLabel, MenuItem, Select, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress } from "@mui/material";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import { toast } from "react-toastify";
import { useEffect, useRef, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import AntSwitch from "../../../components/AntSwitch";
import React from "react";
import { useEncryptService } from "../../../shared/hooks";
import AddCredentional from "./AddCredentional";
import SkeletonLoader from "../../../modules/dashboard/shared/skeleton_loader";

// Helper function to trim all string values in an object before sending payload
const trimPayload = (obj: any): any => {
    if (obj === null || obj === undefined) return obj;
    if (typeof obj === 'string') return obj.trim();
    if (Array.isArray(obj)) return obj.map(trimPayload);
    if (typeof obj === 'object') {
        const trimmed: any = {};
        for (const key in obj) {
            trimmed[key] = trimPayload(obj[key]);
        }
        return trimmed;
    }
    return obj;
};

const CredentionalDetails = ({ credential, pageReload, creationType, isDarkMode }: any) => {
    const [credentialDetails, setCredentialDetails] = useState<any>(null);
    const [credentialRoles, setCredentialRoles] = useState<any>(null);
    const [isEditable, setIsEditable] = useState(false); // State to toggle edit mode
    const [showPassword, setShowPassword] = useState(false);
    const [sshPasswordTypes, setSSHPasswordTypes] = useState<string[]>([]);
    const [showNodata, setShowNodata] = useState(false);
    const [apiPasswordTypes, setAPIPasswordTypes] = useState([]);
    const [sshVisible, setSshVisible] = useState(false);
    const [apiVisisble, setApiVisible] = useState(false);
    const [windowsVisible, setWindowsVisible] = useState(false);
    const [snmpVisible, setSnmpVisible] = useState(false);
    const [awsVisible, setAwsVisible] = useState(false);
    const [globalCred, setGlobalCred] = useState(false);
    const [passwordType, setPasswordType] = useState("");
    const [code, setCode] = useState("");
    const [personName, setPersonName] = React.useState<string[]>([]);
    const [roleDetails, setRoleDetails] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const rightGridRef = useRef<HTMLDivElement>(null);
    const [rightSkeletonCount, setRightSkeletonCount] = useState(0);
    const [globalCredForm, setGlobalCredForm] = useState(false);
    const [localCredForm, setLocalCredForm] = useState(false);
    const [errors, setErrors] = useState<any>({}); // State to track validation errors
    //const [showPassword, setShowPassword] = useState(false);
    const [showPrivacyPassword, setshowPrivacyPassword] = useState(false);
    const isPrivateKeySelected = passwordType === "private_key" || passwordType === "privateFile";
    const [privateKeyFileName, setPrivateKeyFileName] = useState("");
    const ppkFileInputRef = useRef<HTMLInputElement>(null);
    const [ppkFile, setPpkFile] = useState<File | null>(null);
    const [pemFile, setPemFile] = useState<File | null>(null);
    const [execPasswordEnabled, setExecPasswordEnabled] = useState(false);

    // Confirmation dialog states
    const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const { doEncryptLogin } = useEncryptService();

    const validateField = (field: string, value: string) => {
        if (!value || value.length < 3 || value.length > 20) {
            setErrors((prev: any) => ({
                ...prev,
                [field]: "Required and must be between 3 and 20 characters.",
            }));
        } else {
            setErrors((prev: any) => {
                const { [field]: _, ...rest } = prev;
                return rest;
            });
        }
    };

    useEffect(() => {
        if (rightGridRef.current) {
            const gridHeight = rightGridRef.current.offsetHeight;
            const count = Math.floor(gridHeight / 40);
            setRightSkeletonCount(count);
        }
        fetchCredentialTypes();
        setIsLoading(true);
        if (credential) {
            setShowNodata(false);
        } else {
            setShowNodata(true);
        }
    }, [credential]);

    useEffect(() => {
        if (credential) {
            fetchUserList();
            fetchRoles();
        }
    }, [sshPasswordTypes])

    useEffect(() => {
        setGlobalCredForm(creationType === "global" ? true : false);
        setLocalCredForm(creationType === "local" ? true : false);
    }, [creationType])

    const fetchRoles = async () => {
        const url = `${END_POINTS.ORG_ROLES}`;
        const payload = {
            order_column: "name",
            sort_by: "ASC"
        }
        try {
            const response = await axiosInstance.post(url, payload);
            if (response.status === 200) {
                setRoleDetails(response.data?.data);
            }
        } catch (error: any) {
            console.error("Error fetching credential details:", error.response);
            toast.error(
                error.response?.data?.message || "Something went wrong",
                { type: "error" }
            );
        }
    }

    const fetchUserList = async () => {
        setIsLoading(true);
        const url = `${END_POINTS.CREDENTIAL_MGMT}/${credential.id}`;
        try {
            const response = await axiosInstance.get(url);
            if (response.status === 200) {
                setCredentialDetails(response.data?.data);
                console.log("Credential Details:", response.data?.data);
                setErrors({});
                setIsEditable(false); // Disable edit mode after fetching data
                checkTabChange(response.data?.data);
                setTimeout(() => {
                    setIsLoading(false);
                }, 500);
            }
        } catch (error: any) {
            console.error("Error fetching credential details:", error.response);
            setIsLoading(false);
            toast.error(
                error.response?.data?.message || "Something went wrong",
                { type: "error" }
            );
        }
    };

    const deleteCredential = async () => {
        setIsDeleting(true);
        const url = `${END_POINTS.CREDENTIAL_MGMT}/${credential.id}`;
        try {
            const response = await axiosInstance.delete(url);
            if (response.status === 200) {
                toast.success(response?.data?.message || "Credential deleted successfully!");
                setIsDeleteDialogOpen(false);
                pageReload();
            }
        } catch (error: any) {
            console.error("Error fetching credential details:", error.response);
            toast.error(
                error.response?.data?.message || "Something went wrong",
                { type: "error" }
            );
        } finally {
            setIsDeleting(false);
        }
    };

    // Dialog handlers
    const handleCancelDialogOpen = () => setIsCancelDialogOpen(true);
    const handleCancelDialogClose = () => setIsCancelDialogOpen(false);
    const handleConfirmCancel = () => {
        setIsCancelDialogOpen(false);
        setIsEditable(false);
        fetchUserList();
    };

    const handleDeleteDialogOpen = () => setIsDeleteDialogOpen(true);
    const handleDeleteDialogClose = () => setIsDeleteDialogOpen(false);

    const fetchCredentialTypes = async () => {
        try {
            const response = await axiosInstance.get(END_POINTS.CREDENTIAL_TYPES);
            if (response.status === 200) {
                setCredentialRoles(response?.data?.data);
                console.log("Parsed Data:", setCredentialRoles);
                response?.data?.data?.map((obj: any) => {
                    if (obj.code === "ssh") {
                        setSSHPasswordTypes(obj?.password_type)
                    } else if (obj.code === "api") {
                        setAPIPasswordTypes(obj?.password_type)
                    } else if (obj.code === "windows") {
                        setAPIPasswordTypes(obj?.password_type)
                    } else if (obj.code === "snmp") {
                        setAPIPasswordTypes(obj?.password_type)
                    }
                })

            }
        } catch (error: any) {
            console.error("Error fetching agent list:", error.response);
            toast.error(
                error.response?.data?.message || "Something went wrong",
                { type: "error" }
            );
        }
    };

    const checkTabChange = (cred_data: any) => {
        console.log(cred_data, "cred_data");
        if (cred_data) {
            setGlobalCred(cred_data.global_cred);
            // Get all credential type ids for each type
            // const sshPasswordtypeIds = sshPasswordTypes.map((obj: any) => obj.id);
            const sshPasswordtypeIds = credentialRoles?.find((obj: any) => obj.code === "ssh")?.password_type?.map((obj: any) => obj.id) || [];
            const windowsTypeIds = credentialRoles?.find((obj: any) => obj.code === "windows")?.password_type?.map((obj: any) => obj.id) || [];
            const snmpTypeIds = credentialRoles?.find((obj: any) => obj.code === "snmp")?.password_type?.map((obj: any) => obj.id) || [];
            const apiTypeIds = credentialRoles?.find((obj: any) => obj.code === "api")?.password_type?.map((obj: any) => obj.id) || [];
            const awsTypeIds = credentialRoles?.find((obj: any) => obj.code === "aws")?.password_type?.map((obj: any) => obj.id) || [];
            // SSH
            if (sshPasswordtypeIds.includes(cred_data?.credential_type_id as string)) {
                setSshVisible(true);
                setApiVisible(false);
                setWindowsVisible(false);
                setSnmpVisible(false);
                setAwsVisible(false);
                const sshTypeObj = credentialRoles
                    ?.find((obj: any) => obj.code === "ssh")
                    ?.password_type?.find((type: any) => type.id === cred_data.credential_type_id);
                setPasswordType(sshTypeObj?.code || "password");
                setCode("ssh");

            }
            // WINDOWS
            else if (windowsTypeIds.includes(cred_data?.credential_type_id as string)) {
                setWindowsVisible(true);
                setSshVisible(false);
                setApiVisible(false);
                setSnmpVisible(false);
                setAwsVisible(false);
                const windowsTypeObj = credentialRoles
                    ?.find((obj: any) => obj.code === "windows")
                    ?.password_type?.find((type: any) => type.id === cred_data.credential_type_id);
                setPasswordType(windowsTypeObj?.code || "password");
                setCode("windows");
            }
            // SNMP
            else if (snmpTypeIds.includes(cred_data?.credential_type_id as string)) {
                setSnmpVisible(true);
                setSshVisible(false);
                setApiVisible(false);
                setWindowsVisible(false);
                setAwsVisible(false);
                // Set passwordType based on code
                const snmpTypeObj = credentialRoles?.find((obj: any) => obj.code === "snmp")?.password_type?.find((type: any) => type.id === cred_data.credential_type_id);
                setPasswordType(snmpTypeObj?.code || "");
                setCode("snmp");
            }
            // API
            else if (apiTypeIds.includes(cred_data?.credential_type_id as string)) {
                setApiVisible(true);
                setSshVisible(false);
                setWindowsVisible(false);
                setSnmpVisible(false);
                setAwsVisible(false);
                const apiTypeObj = credentialRoles
                    ?.find((obj: any) => obj.code === "api")
                    ?.password_type?.find((type: any) => type.id === cred_data.credential_type_id);
                setPasswordType(apiTypeObj?.code || "");
                setCode("api");
            }
            // AWS
            else if (awsTypeIds.includes(cred_data?.credential_type_id as string)) {
                setAwsVisible(true);
                setSshVisible(false);
                setWindowsVisible(false);
                setSnmpVisible(false);
                setApiVisible(false);
                const awsTypeObj = credentialRoles
                    ?.find((obj: any) => obj.code === "aws")
                    ?.password_type?.find((type: any) => type.id === cred_data.credential_type_id);
                setPasswordType(awsTypeObj?.code || "");
                setCode("aws");
            }
            if (cred_data.role_id && cred_data.global_cred) {
                const roleIdsToFind = cred_data.role_id
                const matchingRoles = roleDetails.filter((role: any) => roleIdsToFind.includes(role.id));
                matchingRoles.forEach((role: any) => {
                    setPersonName((prev) => [...prev, role.name]);
                });

                if (!personName && cred_data.global_cred) {
                    roleDetails.forEach((role: { name: string; id: any; }) => {
                        if (role.name === "Admin") {
                            setPersonName((prev) => [...prev, role.name]);
                        }
                    });

                }
            }
        }
    }

    const handleEditClick = () => {
        setIsEditable(true); // Enable edit mode
    };

    const handleSaveClick = async () => {

        const selectedRole = credentialRoles.find((role: any) => role.code === code);
        let matchedPasswordType;
        if (selectedRole && selectedRole.password_type) {
            matchedPasswordType = selectedRole.password_type.find((pt: any) => pt.code === passwordType);
        }
        console.log("Matched Password Type:", matchedPasswordType);

        let payload: any = {
            "cred_id": credential.id,
            "cred_name": credentialDetails.name,
            "global_cred": globalCred,
            "username": credentialDetails.username,
            "description": credentialDetails.description,
            "enable_password": credentialDetails.enable_password,
        }
        // Trim all string values in payload
        payload = trimPayload(payload);

        if (credentialDetails.auto_assign) {
            payload.auto_assign = true;
            delete payload.enable_password;
        }
        else {
            payload.auto_assign = false;
        }
        if (execPasswordEnabled) {
            payload = Object.assign(payload, {
                enable_password: doEncryptLogin(payload.enable_password)
            })
            payload.exec_password = true
        }
        else {
            payload.exec_password = false
        }
        const isPrivateKeySelected = passwordType === "private_key" || passwordType === "privateFile";

        if (passwordType === "password") {
            payload.password = credentialDetails.password;
            payload = Object.assign(payload, {
                password: doEncryptLogin(payload.password?.trim())
            })
            // const passwordType = credentialRoles[0].password_type.find((type: { code: string; }) => type.code === 'password');
            // if (passwordType) {
            //     payload.credential_type_id = passwordType.id;
            // }
        }
        if (apiVisisble) {
            payload.encrypt = true
            payload.api_token = doEncryptLogin(credentialDetails.api_token?.trim());

        }
        if (matchedPasswordType) {
            payload.credential_type_id = matchedPasswordType.id;
        }

        if (code == "snmp") {
            if (passwordType === "snmp_password_v3") {
                // SNMP v3 requires username, auth_password, priv_password, auth_protocol, priv_protocol
                payload.auth_protocol = doEncryptLogin(credentialDetails.auth_protocol?.trim());
                payload.auth_password = doEncryptLogin(credentialDetails.auth_password?.trim());
                payload.priv_protocol = doEncryptLogin(credentialDetails.priv_protocol?.trim());
                payload.priv_password = doEncryptLogin(credentialDetails.priv_password?.trim());
                payload.username = doEncryptLogin(credentialDetails.username?.trim());
                // Remove fields not needed for v3
                delete payload.community_string;
                delete payload.exec_password;
                delete payload.enable_password;
                delete payload.auto_assign;
            } else {
                // Community string for v1, v2c
                payload.community_string = doEncryptLogin(credentialDetails.username?.trim());
                // Remove username for community string
                delete payload.username;
            }
        } else if (code === "aws") {
            payload.account_id = doEncryptLogin(credentialDetails.account_id?.trim());
            payload.access_key = doEncryptLogin(credentialDetails.access_key?.trim());
            payload.secret_key = doEncryptLogin(credentialDetails.secret_key?.trim());
            delete payload.username;
            delete payload.password;
            delete payload.exec_password;
            delete payload.enable_password;
            delete payload.user_name;
            delete payload.auto_assign;
        } else {
            payload = Object.assign(payload, {
                username: doEncryptLogin(payload.username),
            })

        }

        payload.encrypt = true;

        if (isPrivateKeySelected) {
            const keyFile = ppkFile || pemFile;
            if (!keyFile) {
                toast.error("Please upload a PEM file");
                return;
            }

            const formData = new FormData();

            Object.entries(payload).forEach(([key, value]) => {
                if (value === undefined || value === null) {
                    return;
                }

                if (Array.isArray(value)) {
                    formData.append(key, JSON.stringify(value));
                    return;
                }

                if (typeof value === "boolean") {
                    formData.append(key, value ? "true" : "false");
                    return;
                }

                formData.append(key, value as any);
            });

            formData.append("private_key", keyFile);

            try {
                const response = await axiosInstance.put(END_POINTS.CREDENTIAL_MGMT, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.status === 200) {
                    toast.success("Credential updated successfully!");
                    setIsEditable(false);
                    fetchUserList();
                }
            } catch (error: any) {
                console.error("Error updating credential:", error.response);
                toast.error(
                    error.response?.data?.message || "Failed to update credential",
                    { type: "error" }
                );
            }
            return;
        }

        setIsEditable(false);
        try {
            const response = await axiosInstance.put(END_POINTS.CREDENTIAL_MGMT, payload);
            if (response.status === 200) {
                toast.success("Credential updated successfully!");
                setIsEditable(false);
                fetchUserList();
            }
        } catch (error: any) {
            console.error("Error updating credential:", error.response);
            toast.error(
                error.response?.data?.message || "Failed to update credential",
                { type: "error" }
            );
        }
    };

    const handleInputChange = (field: string, value: any) => {
        setCredentialDetails((prev: any) => ({
            ...prev,
            [field]: value,
        }));
        validateField(field, value); // Validate the field on change
    };

    const handlePasswordInputChange = (value: any) => {
        setPasswordType(value);
    };

    const handleToggleChangeExecPassword = (value: boolean) => {
        setExecPasswordEnabled(value);
        setCredentialDetails((prev: any) => ({
            ...prev,
            exec_password: value, // Update only the Exec Password field
        }));
        // setExecPasswordToogle(value);
    };

    const handleToggleChangeAutoAssign = (value: boolean) => {
        setCredentialDetails((prev: any) => ({
            ...prev,
            auto_assign: value,
        }));
        // setAutoAssignToggle(value);
    };

    const handlePpkFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            // Validate file extension
            const fileName = file.name.toLowerCase();
            if (!fileName.endsWith('.pem')) {
                toast.error("Please upload a PEM file (.pem)");
                if (ppkFileInputRef.current) {
                    ppkFileInputRef.current.value = '';
                }
                return;
            }
            setPpkFile(file);
            setPemFile(file);
            setPrivateKeyFileName(file.name);
        }
    };

    const handlePpkUploadClick = () => {
        ppkFileInputRef.current?.click();
    };


    return (
        <>
            <Card
                sx={{
                    width: '100%',
                    height: '100%',
                    fontFamily: 'Manrope',
                    fontWeight: 700,
                    fontSize: "15px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    padding: "0px",
                    // display: "flex",
                    // alignItems: "center",
                    // justifyContent: "center",
                }}
                className="white-box"
            >
                {credential && !globalCredForm && !localCredForm && (
                    <>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "11px 20px",
                                borderBottom: "1px solid #E2E2F2",
                            }}
                        >
                            <h3
                                style={{
                                    margin: "0",
                                    fontSize: "15px",
                                    fontWeight: "700",
                                    lineHeight: "20px",
                                }}
                            >
                                {credential && credential.type}
                            </h3>
                            <div>
                                {!isEditable ? (
                                    <div>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            onClick={handleEditClick}
                                            sx={{ border: "1px solid blue", width: "86px", marginRight: '12px' }}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={handleDeleteDialogOpen}
                                            sx={{ border: "1px solid #F03C3C", width: "86px", color: "#F03C3C" }}
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                ) : (
                                    <div>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            onClick={handleCancelDialogOpen}
                                            sx={{ border: "1px solid blue", width: "86px", marginRight: '12px' }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            onClick={handleSaveClick} // Save changes and disable edit mode
                                            sx={{ border: "1px solid blue", width: "86px" }}
                                            disabled={Object.keys(errors).length > 0 || !isEditable || !credentialDetails?.name || credentialDetails?.name?.trim()?.length < 3} // Disable if there are errors, not in edit mode, or credential name < 3 chars
                                        >
                                            Save
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div >

                            {isLoading ? (
                                <SkeletonLoader
                                    count={Math.floor(window.innerHeight / 40)}
                                    styles={{ height: 30 }}
                                />
                            ) : credentialDetails ? (
                                <Box sx={{ mt: 2, p: 2 }}>
                                    <div style={{ display: 'flex', gap: '10vh', justifyContent: 'center', overflowY: 'auto', height: 'calc(100vh - 235px)' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '22%', }}>
                                            {/* SSH */}
                                            {sshVisible && (
                                                <>
                                                    <TextField
                                                        sx={{ mt: 1.5 }}
                                                        label="Credential Name"
                                                        value={credentialDetails.name || ""}
                                                        onChange={(e) => handleInputChange("name", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable, // Toggle read-only mode
                                                        }}
                                                        disabled={!isEditable}
                                                        error={!!errors.name}
                                                        helperText={errors.name}
                                                    />
                                                    <TextField
                                                        label="User"
                                                        value={credentialDetails.username || ""}
                                                        onChange={(e) => handleInputChange("username", e.target.value)} // Handle input change
                                                        disabled={!isEditable}
                                                        error={!!errors.username}
                                                        helperText={errors.username}
                                                    />
                                                    <TextField
                                                        label="Description"
                                                        value={credentialDetails.description || ""}
                                                        onChange={(e) => handleInputChange("description", e.target.value)} // Handle input change
                                                        disabled={!isEditable}
                                                        error={!!errors.description}
                                                        helperText={errors.description}
                                                    />
                                                    {passwordType === "password" && (
                                                        <TextField
                                                            label="Password"
                                                            type={showPassword ? "text" : "password"}
                                                            fullWidth
                                                            value={credentialDetails.password || ""}
                                                            onChange={(e) => handleInputChange("password", e.target.value)}
                                                            error={!!errors.password}
                                                            helperText={errors.password}
                                                            disabled={!isEditable}
                                                            slotProps={{
                                                                input: {
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <span className="visibility-icon">
                                                                                {showPassword ? (
                                                                                    <Visibility
                                                                                        onClick={() => isEditable && setShowPassword(!showPassword)}
                                                                                        sx={{
                                                                                            cursor: isEditable ? 'pointer' : 'not-allowed',
                                                                                            opacity: isEditable ? 1 : 0.5,
                                                                                            pointerEvents: isEditable ? 'auto' : 'none'
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <VisibilityOff
                                                                                        onClick={() => isEditable && setShowPassword(!showPassword)}
                                                                                        sx={{
                                                                                            cursor: isEditable ? 'pointer' : 'not-allowed',
                                                                                            opacity: isEditable ? 1 : 0.5,
                                                                                            pointerEvents: isEditable ? 'auto' : 'none'
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </span>
                                                                        </InputAdornment>
                                                                    ),
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    {passwordType === "privateFile" || (isEditable && isPrivateKeySelected) && (
                                                        <Box
                                                            sx={{
                                                                border: "1px dashed #3a2ada",
                                                                padding: "10px",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            <input
                                                                type="file"
                                                                accept=".pem"
                                                                ref={ppkFileInputRef}
                                                                onChange={handlePpkFileChange}
                                                                style={{ display: "none" }}
                                                            />
                                                            <Button
                                                                variant="contained"
                                                                onClick={handlePpkUploadClick}
                                                                sx={{
                                                                    backgroundColor: "#3A2AdA",
                                                                    color: "white",
                                                                    "&:hover": {
                                                                        backgroundColor: "#3225b7",
                                                                    },
                                                                }}
                                                            >
                                                                Upload PEM File
                                                            </Button>
                                                            {privateKeyFileName && (
                                                                <Box sx={{ mt: 1, fontSize: "12px", color: "text.secondary" }}>
                                                                    Selected: {privateKeyFileName}
                                                                </Box>
                                                            )}
                                                            <Box>
                                                                <p>If a PPK file is available, it should be converted into a PEM file</p>
                                                            </Box>
                                                        </Box>
                                                    )}
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <p>Exec Password</p>
                                                        <AntSwitch
                                                            checked={execPasswordEnabled}
                                                            onChange={(e) => handleToggleChangeExecPassword(e.target.checked)}
                                                            disabled={credentialDetails.auto_assign || !isEditable}
                                                        />
                                                    </div>
                                                    {execPasswordEnabled && (
                                                        <TextField
                                                            label="Exec Password"
                                                            type={showPassword ? "text" : "password"}
                                                            fullWidth
                                                            value={credentialDetails.enable_password || ""}
                                                            onChange={(e) => handleInputChange("enable_password", e.target.value)} // Optional field
                                                            InputProps={{
                                                                readOnly: !isEditable,
                                                            }}
                                                        />
                                                    )}
                                                    {!credentialDetails.exec_password && passwordType !== "private_key" && (
                                                        <div>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                <p>Auto Assign</p>
                                                                <AntSwitch
                                                                    checked={credentialDetails.auto_assign || false}
                                                                    onChange={(e) => handleToggleChangeAutoAssign(e.target.checked)}
                                                                    disabled={!isEditable}
                                                                />
                                                            </div>
                                                            <p>This will auto-assign Login Password as Exec Password when missing.</p>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            {/* WINDOWS */}
                                            {windowsVisible && (
                                                <>
                                                    <TextField
                                                        sx={{ mt: 1.5 }}
                                                        label="Credential Name"
                                                        value={credentialDetails.name || ""}
                                                        onChange={(e) => handleInputChange("name", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable, // Toggle read-only mode
                                                        }}
                                                        error={!!errors.name}
                                                        helperText={errors.name}
                                                    />
                                                    <TextField
                                                        label="Description"
                                                        value={credentialDetails.description || ""}
                                                        onChange={(e) => handleInputChange("description", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable,
                                                        }}
                                                        error={!!errors.description}
                                                        helperText={errors.description}
                                                    />
                                                    <TextField
                                                        label="User Name"
                                                        value={credentialDetails.username || ""}
                                                        onChange={(e) => handleInputChange("username", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable, // Toggle read-only mode
                                                        }}
                                                        error={!!errors.username}
                                                        helperText={errors.username}
                                                    />

                                                    <TextField
                                                        label="Password"
                                                        type={showPassword ? "text" : "password"}
                                                        fullWidth
                                                        value={credentialDetails.password || ""}
                                                        onChange={(e) => handleInputChange("password", e.target.value)}
                                                        error={!!errors.password}
                                                        helperText={errors.password}
                                                        InputProps={{
                                                            readOnly: !isEditable,
                                                        }}
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <span className="visibility-icon">
                                                                            {showPassword ? (
                                                                                <Visibility
                                                                                    onClick={() => isEditable && setShowPassword(!showPassword)}
                                                                                    sx={{
                                                                                        cursor: isEditable ? 'pointer' : 'not-allowed',
                                                                                        opacity: isEditable ? 1 : 0.5,
                                                                                        pointerEvents: isEditable ? 'auto' : 'none'
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <VisibilityOff
                                                                                    onClick={() => isEditable && setShowPassword(!showPassword)}
                                                                                    sx={{
                                                                                        cursor: isEditable ? 'pointer' : 'not-allowed',
                                                                                        opacity: isEditable ? 1 : 0.5,
                                                                                        pointerEvents: isEditable ? 'auto' : 'none'
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </span>
                                                                    </InputAdornment>
                                                                ),
                                                            },
                                                        }}
                                                    />
                                                </>
                                            )}
                                            {/* SNMP */}
                                            {snmpVisible && (
                                                <>
                                                    <TextField
                                                        sx={{ mt: 1.5 }}
                                                        label="Credential Name"
                                                        value={credentialDetails.name || ""}
                                                        onChange={(e) => handleInputChange("name", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable, // Toggle read-only mode
                                                        }}
                                                        error={!!errors.name}
                                                        helperText={errors.name}
                                                    />
                                                    <TextField
                                                        label="Description"
                                                        value={credentialDetails.description || ""}
                                                        onChange={(e) => handleInputChange("description", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable,
                                                        }}
                                                        error={!!errors.description}
                                                        helperText={errors.description}
                                                    />
                                                    {/* Show field based on passwordType */}
                                                    {passwordType === "community_string" && (
                                                        <>
                                                            <TextField
                                                                label="Community String"
                                                                value={credentialDetails.community_string || ""}
                                                                onChange={(e) => handleInputChange("community_string", e.target.value)} // Handle input change
                                                                InputProps={{
                                                                    readOnly: !isEditable, // Toggle read-only mode
                                                                }}
                                                                error={!!errors.username}
                                                                helperText={errors.username}
                                                            />
                                                            {/* <TextField
                                                                    label="Community String"
                                                                    type={showPassword ? "text" : "password"}
                                                                    fullWidth
                                                                    value={credentialDetails.community_string || ""}
                                                                    onChange={(e) => handleInputChange("password", e.target.value)}
                                                                    error={!!errors.password}
                                                                    helperText={errors.password}
                                                                    slotProps={{
                                                                        input: {
                                                                            endAdornment: (
                                                                                <InputAdornment position="end">
                                                                                    <span className="visibility-icon">
                                                                                        {showPassword ? (
                                                                                            <Visibility
                                                                                                onClick={() => setShowPassword(!showPassword)}
                                                                                            />
                                                                                        ) : (
                                                                                            <VisibilityOff
                                                                                                onClick={() => setShowPassword(!showPassword)}
                                                                                            />
                                                                                        )}
                                                                                    </span>
                                                                                </InputAdornment>
                                                                            ),
                                                                        },
                                                                    }}
                                                                /> */}



                                                        </>

                                                    )}
                                                    {passwordType === "snmp_password_v3" && (
                                                        <>

                                                            <TextField
                                                                label="User Name"
                                                                value={credentialDetails.username || ""}
                                                                onChange={(e) => handleInputChange("username", e.target.value)} // Handle input change
                                                                InputProps={{
                                                                    readOnly: !isEditable, // Toggle read-only mode
                                                                }}
                                                                error={!!errors.username}
                                                                helperText={errors.username}
                                                            />
                                                            <FormControl fullWidth sx={{ mb: 1 }}>
                                                                <InputLabel id="auth-protocol-label" sx={{ fontSize: '12px' }}>Authentication Protocol</InputLabel>
                                                                <Select
                                                                    disabled={!isEditable}
                                                                    sx={{
                                                                        height: '40px',
                                                                        display: 'flex',
                                                                        alignItems: 'center', // Center text vertically
                                                                        fontSize: '14px',
                                                                        '& .MuiSelect-select': {
                                                                            display: 'flex',
                                                                            alignItems: 'center', // Center content vertically
                                                                            paddingTop: '8px',     // Optional: fine-tune vertical spacing
                                                                            paddingBottom: '8px',
                                                                        },
                                                                    }}
                                                                    labelId="auth-protocol-label"
                                                                    id="auth-protocol-select"
                                                                    value={credentialDetails.auth_protocol || ""}
                                                                    label="Authentication Protocol"
                                                                    onChange={(e) => handleInputChange("auth_protocol", e.target.value)}
                                                                >
                                                                    <MenuItem value="md5">md5</MenuItem>
                                                                    <MenuItem value="sha">sha</MenuItem>
                                                                    <MenuItem value="sha224">sha224</MenuItem>
                                                                    <MenuItem value="sha256">sha256</MenuItem>
                                                                    <MenuItem value="sha384">sha384</MenuItem>
                                                                    <MenuItem value="sha512">sha512</MenuItem>
                                                                    <MenuItem value="none">none</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                            <TextField
                                                                label="Authentication Password"
                                                                value={credentialDetails.auth_password || ""}
                                                                onChange={(e) => handleInputChange("auth_password", e.target.value)}
                                                                fullWidth
                                                                InputProps={{
                                                                    readOnly: !isEditable,
                                                                }}
                                                            />

                                                            <FormControl fullWidth sx={{ mb: 1 }}>
                                                                <InputLabel id="auth-protocol-label" sx={{ fontSize: '12px' }}>Privacy Protocol</InputLabel>

                                                                <Select
                                                                    disabled={!isEditable}
                                                                    sx={{
                                                                        height: '40px',
                                                                        display: 'flex',
                                                                        alignItems: 'center', // Center text vertically
                                                                        fontSize: '14px',
                                                                        '& .MuiSelect-select': {
                                                                            display: 'flex',
                                                                            alignItems: 'center', // Center content vertically
                                                                            paddingTop: '8px',     // Optional: fine-tune vertical spacing
                                                                            paddingBottom: '8px',
                                                                        },
                                                                    }}
                                                                    labelId="privacy-protocol-label"
                                                                    id="privacy-protocol-select"
                                                                    value={credentialDetails.priv_protocol || ""}
                                                                    label="Privacy Protocol"
                                                                    onChange={(e) => handleInputChange("priv_protocol", e.target.value)}
                                                                >
                                                                    <MenuItem value="des">des</MenuItem>
                                                                    <MenuItem value="3des">3des</MenuItem>
                                                                    <MenuItem value="aes">aes</MenuItem>
                                                                    <MenuItem value="aes128">aes128</MenuItem>
                                                                    <MenuItem value="aes192">aes192</MenuItem>
                                                                    <MenuItem value="aes256">aes256</MenuItem>
                                                                    <MenuItem value="none">none</MenuItem>
                                                                </Select>
                                                            </FormControl>

                                                            <TextField
                                                                label="Privacy Password"
                                                                value={credentialDetails.priv_password || ""}
                                                                onChange={(e) => handleInputChange("priv_password", e.target.value)}
                                                                type={showPrivacyPassword ? "text" : "password"}
                                                                InputProps={{
                                                                    readOnly: !isEditable,
                                                                }}
                                                                fullWidth
                                                                slotProps={{
                                                                    input: {
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <span className="visibility-icon">
                                                                                    {showPrivacyPassword ? (
                                                                                        <Visibility
                                                                                            onClick={() => isEditable && setshowPrivacyPassword(!showPrivacyPassword)}
                                                                                            sx={{
                                                                                                cursor: isEditable ? 'pointer' : 'not-allowed',
                                                                                                opacity: isEditable ? 1 : 0.5,
                                                                                                pointerEvents: isEditable ? 'auto' : 'none'
                                                                                            }}
                                                                                        />
                                                                                    ) : (
                                                                                        <VisibilityOff
                                                                                            onClick={() => isEditable && setshowPrivacyPassword(!showPrivacyPassword)}
                                                                                            sx={{
                                                                                                cursor: isEditable ? 'pointer' : 'not-allowed',
                                                                                                opacity: isEditable ? 1 : 0.5,
                                                                                                pointerEvents: isEditable ? 'auto' : 'none'
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                </span>
                                                                            </InputAdornment>
                                                                        ),
                                                                    },
                                                                }}
                                                            />
                                                            {/* <TextField
                                                                    label="Password"
                                                                    type={showPassword ? "text" : "password"}
                                                                    fullWidth
                                                                    value={credentialDetails.password || ""}
                                                                    onChange={(e) => handleInputChange("password", e.target.value)}
                                                                    error={!!errors.password}
                                                                    helperText={errors.password}
                                                                    slotProps={{
                                                                        input: {
                                                                            endAdornment: (
                                                                                <InputAdornment position="end">
                                                                                    <span className="visibility-icon">
                                                                                        {showPassword ? (
                                                                                            <Visibility
                                                                                                onClick={() => setShowPassword(!showPassword)}
                                                                                            />
                                                                                        ) : (
                                                                                            <VisibilityOff
                                                                                                onClick={() => setShowPassword(!showPassword)}
                                                                                            />
                                                                                        )}
                                                                                    </span>
                                                                                </InputAdornment>
                                                                            ),
                                                                        },
                                                                    }}
                                                                /> */}


                                                        </>



                                                    )}
                                                </>
                                            )}
                                            {apiVisisble && (
                                                <>
                                                    <TextField
                                                        sx={{ mt: 1.5 }}
                                                        label="Credential Name"
                                                        value={credentialDetails.name || ""}
                                                        onChange={(e) => handleInputChange("name", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable, // Toggle read-only mode
                                                        }}
                                                        error={!!errors.name}
                                                        helperText={errors.name}
                                                    />
                                                    <TextField
                                                        label="Description"
                                                        value={credentialDetails.description || ""}
                                                        onChange={(e) => handleInputChange("description", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable,
                                                        }}
                                                        error={!!errors.description}
                                                        helperText={errors.description}
                                                    />
                                                    <TextField
                                                        label="API Token"
                                                        value={credentialDetails.api_token || ""}
                                                        onChange={(e) => handleInputChange("api_token", e.target.value)}
                                                        InputProps={{
                                                            readOnly: !isEditable, // Toggle read-only mode
                                                        }}
                                                    />
                                                </>

                                            )}

                                            {awsVisible && (
                                                <>
                                                    <TextField
                                                        sx={{ mt: 1.5 }}
                                                        label="Credential Name"
                                                        value={credentialDetails.name || ""}
                                                        onChange={(e) => handleInputChange("name", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable, // Toggle read-only mode
                                                        }}
                                                        disabled={!isEditable}
                                                        error={!!errors.name}
                                                        helperText={errors.name}
                                                    />
                                                    <TextField
                                                        label="Description"
                                                        value={credentialDetails.description || ""}
                                                        onChange={(e) => handleInputChange("description", e.target.value)} // Handle input change
                                                        InputProps={{
                                                            readOnly: !isEditable,
                                                        }}
                                                        disabled={!isEditable}
                                                        error={!!errors.description}
                                                        helperText={errors.description}
                                                    />
                                                    <TextField
                                                        label="Account ID"
                                                        value={credentialDetails.account_id || ""}
                                                        onChange={(e) => handleInputChange("account_id", e.target.value)}
                                                        InputProps={{
                                                            readOnly: !isEditable,
                                                        }}
                                                        disabled={!isEditable}
                                                    />
                                                    <TextField
                                                        label="Access Key"
                                                        value={credentialDetails.access_key || ""}
                                                        onChange={(e) => handleInputChange("access_key", e.target.value)}
                                                        InputProps={{
                                                            readOnly: !isEditable,
                                                        }}
                                                        disabled={!isEditable}
                                                    />
                                                    <TextField
                                                        label="Secret Key"
                                                        type={showPassword ? "text" : "password"}
                                                        fullWidth
                                                        value={credentialDetails.secret_key || ""}
                                                        onChange={(e) => handleInputChange("secret_key", e.target.value)}
                                                        error={!!errors.password}
                                                        helperText={errors.password}
                                                        disabled={!isEditable}
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <span className="visibility-icon">
                                                                            {showPassword ? (
                                                                                <Visibility
                                                                                    onClick={() => isEditable && setShowPassword(!showPassword)}
                                                                                    sx={{
                                                                                        cursor: isEditable ? 'pointer' : 'not-allowed',
                                                                                        opacity: isEditable ? 1 : 0.5,
                                                                                        pointerEvents: isEditable ? 'auto' : 'none'
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <VisibilityOff
                                                                                    onClick={() => isEditable && setShowPassword(!showPassword)}
                                                                                    sx={{
                                                                                        cursor: isEditable ? 'pointer' : 'not-allowed',
                                                                                        opacity: isEditable ? 1 : 0.5,
                                                                                        pointerEvents: isEditable ? 'auto' : 'none'
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </span>
                                                                    </InputAdornment>
                                                                ),
                                                            },
                                                        }}
                                                    />
                                                </>
                                            )}

                                            {/* {globalCred && !windowsVisible && !snmpVisible && (
                                                <div>
                                                    <FormControl sx={{ width: '100%', }}>
                                                        <InputLabel id="multiple-checkbox-label">Select Role</InputLabel>
                                                        <Select
                                                            labelId="multiple-checkbox-label"
                                                            id="multiple-checkbox"
                                                            multiple
                                                            sx={{ height: '50px' }}
                                                            readOnly={!isEditable}
                                                            value={personName}
                                                            onChange={handleChange}
                                                            input={<OutlinedInput label="Select Role" />}
                                                            renderValue={(selected) => {
                                                                const selectedNames = selected
                                                                    .map((id) => {
                                                                        const found = roleDetails.find((role: any) => role.id === id);
                                                                        return found ? found.name : id;
                                                                    });
                                                                const maxChips = 2;
                                                                const displayedChips = selectedNames.slice(0, maxChips);
                                                                const remainingCount = selectedNames.length - maxChips;

                                                                return (
                                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                                                                        {displayedChips.map((name, idx) => (
                                                                            <Chip
                                                                                key={selected[idx]}
                                                                                label={name}
                                                                                style={{ backgroundColor: isDarkMode ? '# 535a6b' : 'white' }}
                                                                            />
                                                                        ))}
                                                                        {remainingCount > 0 && (
                                                                            <Chip
                                                                                label={`+${remainingCount} more`}
                                                                                style={{ fontStyle: 'italic' }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                );
                                                            }}
                                                            MenuProps={SelectMenuProps}
                                                        >
                                                            {roleDetails.map((role: any) => (
                                                                <MenuItem key={role.id} value={role.id}>
                                                                    <Checkbox checked={personName.includes(role.id)} />
                                                                    <ListItemText primary={role.name} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            )} */}


                                        </div>
                                        <div>
                                            {/* SSH password type selection */}
                                            {sshVisible && (
                                                <>
                                                    <p>Password Type</p>
                                                    <RadioGroup
                                                        row
                                                        value={passwordType || "none"}
                                                        onChange={(e) => {
                                                            const selectedValue = e.target.value;
                                                            setPasswordType(selectedValue);
                                                            handlePasswordInputChange(selectedValue);
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            value="password"
                                                            control={<Radio disabled={!isEditable} />}
                                                            label="Password"
                                                            sx={{
                                                                '& .MuiRadio-root.Mui-checked': {
                                                                    color: 'blue',
                                                                },
                                                            }}
                                                        />
                                                        <FormControlLabel
                                                            value="private_key"
                                                            control={<Radio disabled={!isEditable} />}
                                                            label="Private Key"
                                                            sx={{
                                                                '& .MuiRadio-root.Mui-checked': {
                                                                    color: 'blue',
                                                                },
                                                            }}
                                                        />
                                                        {/* <FormControlLabel
                                                            value="none"
                                                            control={<Radio disabled={!isEditable} />}
                                                            label="None"
                                                            sx={{
                                                                '& .MuiRadio-root.Mui-checked': {
                                                                    color: 'blue', // Highlight color for selected radio button
                                                                },
                                                            }}
                                                        /> */}
                                                    </RadioGroup>
                                                </>
                                            )}
                                            {/* WINDOWS password type selection */}
                                            {windowsVisible && (
                                                <div>
                                                    <p>Password Type</p>
                                                    <RadioGroup
                                                        row
                                                        value={passwordType || "password"}
                                                        onChange={(e) => {
                                                            const selectedValue = e.target.value;
                                                            setPasswordType(selectedValue);
                                                            handlePasswordInputChange(selectedValue);
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            value="password"
                                                            control={<Radio disabled={!isEditable} />}
                                                            label="Password"
                                                            sx={{
                                                                '& .MuiRadio-root.Mui-checked': {
                                                                    color: 'blue',
                                                                },
                                                            }}
                                                        />
                                                    </RadioGroup>
                                                </div>
                                            )}
                                            {/* SNMP password type selection */}
                                            {snmpVisible && (
                                                <div>
                                                    <p>Password Type</p>
                                                    <RadioGroup
                                                        row
                                                        value={passwordType || ""}
                                                        onChange={(e) => {
                                                            const selectedValue = e.target.value;
                                                            setPasswordType(selectedValue);
                                                            handlePasswordInputChange(selectedValue);
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            value="community_string"
                                                            control={<Radio disabled={!isEditable} />}
                                                            label="Community String"
                                                            sx={{
                                                                '& .MuiRadio-root.Mui-checked': {
                                                                    color: 'blue',
                                                                },
                                                            }}
                                                        />
                                                        <FormControlLabel
                                                            value="snmp_password_v3"
                                                            control={<Radio disabled={!isEditable} />}
                                                            label="Password (v3)"
                                                            sx={{
                                                                '& .MuiRadio-root.Mui-checked': {
                                                                    color: 'blue',
                                                                },
                                                            }}
                                                        />
                                                    </RadioGroup>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Box>
                            ) : (
                                <Typography variant="body2" sx={{ mt: 2, fontSize: '18px', textAlign: "center", display: 'flex', justifyContent: 'center' }}>
                                    No data available to show
                                </Typography>
                            )}
                        </div>
                    </>)}
                {globalCredForm && (
                    <AddCredentional credType={true} callFetchUsers={pageReload} />
                )}
                {localCredForm && (
                    <AddCredentional credType={false} callFetchUsers={pageReload} />
                )}
                {!credential && !globalCredForm && !localCredForm && showNodata && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 104px)' }}>
                        <Typography variant="body2" sx={{ mt: 2, fontSize: '14px', textAlign: "center", display: 'flex', justifyContent: 'center' }}>
                            No data available to show
                        </Typography>
                    </div>

                )}
            </Card>

            {/* Cancel Confirmation Dialog */}
            <Dialog
                sx={{
                    "& .MuiDialog-paper": {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "300px",
                        height: "180px",
                        transform: "translate(-50%, -50%)",
                    },
                }}
                open={isCancelDialogOpen}
                onClose={handleCancelDialogClose}
            >
                <DialogTitle>
                    <p className="dialog-title" style={{ textAlign: "center", margin: 0 }}>Are you sure you want to cancel?</p>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ textAlign: "center" }}>
                        Your unsaved changes will be lost.
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                        marginBottom: "15px",
                    }}
                >
                    <Button
                        sx={{ width: "120px", color: "#696595", borderColor: "#696595" }}
                        variant="outlined"
                        onClick={handleCancelDialogClose}
                    >
                        Go Back
                    </Button>
                    <Button
                        sx={{ width: "120px", background: "#F7941F", color: "white" }}
                        onClick={handleConfirmCancel}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog
                sx={{
                    "& .MuiDialog-paper": {
                        width: "280px",
                        borderRadius: "12px",
                        padding: "8px",
                    },
                }}
                open={isDeleteDialogOpen}
                onClose={handleDeleteDialogClose}
            >
                <DialogTitle sx={{ padding: "16px 16px 8px 16px" }}>
                    <p className="dialog-title" style={{ textAlign: "center", margin: 0, fontSize: "14px" }}>Are you sure you want to delete?</p>
                    <p className="dialog-title" style={{ textAlign: "center", margin: "8px 0 0 0", fontSize: "14px", fontWeight: "bold" }}>"{credential?.name}"</p>
                </DialogTitle>
                <DialogActions
                    sx={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                        padding: "8px 16px 16px 16px",
                    }}
                >
                    <Button
                        sx={{ width: "100px", color: "#696595", borderColor: "#696595", fontSize: "13px" }}
                        variant="outlined"
                        onClick={handleDeleteDialogClose}
                        disabled={isDeleting}
                    >
                        Cancel
                    </Button>
                    <Button
                        sx={{
                            width: "100px",
                            background: "#FB4B50",
                            color: "white",
                            fontSize: "13px",
                            "&:disabled": {
                                background: "#FB4B50",
                                color: "white",
                            }
                        }}
                        onClick={deleteCredential}
                        disabled={isDeleting}
                    >
                        {isDeleting ? (
                            <>
                                <CircularProgress size={14} sx={{ color: "white", mr: 1 }} />
                                Deleting
                            </>
                        ) : (
                            "Delete"
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export default CredentionalDetails;